import { render } from "./view-bank.vue?vue&type=template&id=171aff42&lang=html"
import script from "./view-bank.vue?vue&type=script&lang=js"
export * from "./view-bank.vue?vue&type=script&lang=js"

import "./view-bank.vue?vue&type=style&index=0&id=171aff42&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__